import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createTestIdForHeaderClose } from "../../../HeaderClose/utils/createTestId";
import { CoreHeaderLeftAddon } from "../../../general/CoreHeader/components/LeftAddon/CoreHeaderLeftAddon";
import { createDisplayNameForHeader } from "../../utils/createDisplayName";

import type { CoreHeaderLeftAddonProps } from "../../../general/CoreHeader/components/LeftAddon/CoreHeaderLeftAddon";

const displayName = createDisplayNameForHeader("LeftAddon");
const testId = createTestIdForHeaderClose("left-addon");

const HeaderLeftAddon = createComponentPreset<CoreHeaderLeftAddonProps>(
    displayName,
    CoreHeaderLeftAddon,
    {
        "data-tsid": testId,
    },
);
export default HeaderLeftAddon;
